'use client';

import { useEffect, useState } from 'react';
import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import { useIntl } from 'react-intl';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { useShareButtonTracking } from '../Tracking/hooks/useShareButtonTracking';

export type ShareButtonProps = {
  sharedTitle: string;
};

/**
 * Displays a 'share' button wrapped by a grid on browsers that support native web-share-api
 * */

export const ShareButton = ({ sharedTitle }: ShareButtonProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [canShare, setCanShare] = useState(false);

  const { trackButtonClick, trackViewButton } = useShareButtonTracking();
  const { formatMessage } = useIntl();

  useEffect(() => {
    setIsLoading(false);
    if (typeof window !== 'undefined' && typeof window.navigator.share !== 'undefined') {
      trackViewButton();
      setCanShare(true);
    }
  }, [trackViewButton]);

  if (isLoading) {
    return <Skeleton className="h-4.5" />;
  }

  if (!canShare) return null;

  const onClick = async () => {
    trackButtonClick();
    await window.navigator.share({
      title: sharedTitle,
      text: sharedTitle,
      url: window.location.href,
    });
  };

  return (
    <Button onClick={onClick} className="w-full">
      {formatMessage({
        id: 'social.shareButton.text',
        defaultMessage: 'Produkt teilen',
      })}
      <span aria-disabled="true" className="icon-emp-android size-2" />
    </Button>
  );
};
